module.exports = __webpack_public_path__ + "static/img/bg-id.8c27579e.webp";